/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @alias seriesDataPointService */
function seriesDataPointService() {
    /**
     * Returns string representation of {@link Metric} {@link Series} data point.
     * @param {SeriesDataPoint|null} dataPoint
     * @return {string}
     * @public
     */
    function getDataPointHashString(dataPoint) {
        if (!dataPoint) {
            return '';
        }

        const { timestamp, value } = dataPoint;

        return `${timestamp}-${value}`;
    }

    return {
        getDataPointHashString,
    };
}

/**
 * @ngdoc service
 * @name seriesDataPointService
 * @author Alex Malitsky
 * @desc
 *
 *     Service for handling {@link Series} data point.
 *     To be replaced with SeriesDataPoint configItem class.
 */
angular.module('avi/metrics')
    .factory('seriesDataPointService', seriesDataPointService);
